import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  type?: "website" | "article";
  noindex?: boolean;
}

const SITE = "https://capeberkshire.co.uk";

export const SEO = ({ title, description, path = "", type = "website", noindex }: SEOProps) => {
  const url = `${SITE}${path}`;
  const fullTitle = title.includes("Cape Berkshire") ? title : `${title} | Cape Berkshire Asset Management`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      {noindex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default SEO;
